/**
 * open.app.bff.v1.team.GetReply
 */
export interface Response {
  data?: OpenAppBffV1TeamGetReplyTeam;
}

/**
 * open.app.bff.v1.team.GetReply_Team
 */
export interface TeamDetailType {
  /**
   * 预计开发App介绍
   */
  appDescription?: string;
  /**
   * 应用类型
   */
  appType?: AppType;
  /**
   * 电话区号
   */
  areaCode?: string;
  /**
   * 联系人
   */
  contactName?: string;
  /**
   * 创建时间
   */
  createdAt?: Date;
  /**
   * 团队介绍
   */
  description?: string;
  /**
   * 联系邮箱
   */
  email?: string;
  /**
   * 紧急联系人电话
   */
  emergencyContactPhoneNumber?: string;
  /**
   * 团队编号
   */
  id?: string;
  lastReview?: OpenAppBffV1TeamGetReplyReview;
  /**
   * 团队名称
   */
  name?: string;
  /**
   * 现有产品url
   */
  productUrl?: string;
  /**
   * 审核记录集合
   */
  reviews?: OpenAppBffV1TeamGetReplyReview[];
  /**
   * 开发者状态
   */
  status?: DataStatus;
  /**
   * 更新时间
   */
  updatedAt?: Date;
  /**
   * 主账户编号
   */
  userId?: string;
  /**
   * 现有用户规模
   */
  userSize?: UserSize;
  // 是否首次登录
  topicId?: string;
  isLiveService?: any;
}

/**
 * 应用类型
 */
export enum AppType {
  AppTypeAll = 'APP_TYPE_ALL',
  AppTypeSeller = 'APP_TYPE_SELLER',
  AppTypeSupplier = 'APP_TYPE_SUPPLIER',
  AppTypeUnspecified = 'APP_TYPE_UNSPECIFIED',
}

/**
 * open.app.bff.v1.team.GetReply_Review
 */
export interface OpenAppBffV1TeamGetReplyReview {
  /**
   * 创建时间
   */
  createAt?: Date;
  /**
   * 审核失败原因
   */
  rejectedReason?: string;
  /**
   * 审核状态
   */
  status?: LastReviewStatus;
  /**
   * 审核人编号
   */
  userId?: string;
}

/**
 * 审核状态
 */
export enum LastReviewStatus {
  StatusApproved = 'STATUS_APPROVED',
  StatusDraft = 'STATUS_DRAFT',
  StatusRejected = 'STATUS_REJECTED',
  StatusUnderReview = 'STATUS_UNDER_REVIEW',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
}

/**
 * 开发者状态
 */
export enum DataStatus {
  StatusDisable = 'STATUS_DISABLE',
  StatusEnable = 'STATUS_ENABLE',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
}

/**
 * 现有用户规模
 */
export enum UserSize {
  UserSize0_100 = 'USER_SIZE_0_100',
  UserSize1001_5000 = 'USER_SIZE_1001_5000',
  UserSize101_500 = 'USER_SIZE_101_500',
  UserSize501_1000 = 'USER_SIZE_501_1000',
  UserSizeGreaterThan5001 = 'USER_SIZE_GREATER_THAN_5001',
  UserSizeUnspecified = 'USER_SIZE_UNSPECIFIED',
}
